if(typeof BSS_B2B !== 'undefined') {
  
  async function handleMiniCart(){
    try {
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        const cartDrawer = document.querySelector(".qsc2-mini-cart")
        if (cartDrawer) {
          cartDrawer.classList.add("bss-b2b-mini-cart")
          const cartItems = data.items;
          if (cartItems.length) {
            let listCartOrigin = document.querySelectorAll(".cart__item");
            listCartKey = cartItems.map(cartItem=> cartItem.key);
            document.querySelectorAll('.qsc2-product-item-wrapper').forEach((item, i) => {
              item.setAttribute("bss-b2b-cart-item-key", listCartKey[i]);
              const itemOrginalPrice = item.querySelector(".qsc2-product-item__price-wrapper");
              const finalLinePrice = item.querySelector(".qsc2-product-item__line-price-wrapper");
              itemOrginalPrice.setAttribute("bss-b2b-item-original-price", "");
              finalLinePrice.setAttribute("bss-b2b-final-line-price", "");
            });
            document.querySelector(".qsc2-drawer-footer__summary-subtotal-price").setAttribute("bss-b2b-cart-total-price", "");  
          }
        }
      });
      
      return true;
    }catch(e) {
      return false;
    }
  }

  const fixMiniCart = async () => {
    await handleMiniCart();
    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
  
  document.addEventListener("cart-drawer:open", ()=> {
      fixMiniCart();
  })
  document.addEventListener("cart:change", ()=>{
    setTimeout(()=>{
       fixMiniCart();
    },2000)
  })
  document.addEventListener("click", (e)=>{
    const bssCheckout = document.querySelector(".btn.btn-checkout");
    if( BSS_B2B && bssCheckout && e.target.matches(".qsc2-checkout-button")) {
      e.preventDefault();
      e.stopImmediatePropagation();
      bssCheckout.click();
    }
  },true)
}